import axiosInstance from "@/axiosInstance";

const state = () => ({
    trucks: [],
    drivers: [],
    logisticsLoaded: false,
});

const mutations = {
  SET_TRUCKS(state, trucks) {
      state.trucks = trucks;
  },
  SET_DRIVERS(state, drivers) {
    state.drivers = drivers;
},
  SET_LOGISTICS_LOADED(state, loaded) {
      state.logisticsLoaded = loaded;
  },
  CLEAR_LOGISTICS_DATA(state) {
      state.trucks = [];
      state.drivers = [];
      state.logisticsLoaded = false;
  },
};

const actions = {
  async fetchLogisticsData({ state, commit }) {
    if (state.logisticsLoaded) return;
    try {
      const [truckRes, driverRes] = await Promise.all([
        axiosInstance.get("trucks/"),
        axiosInstance.get("drivers/"),
      ]);
      commit("SET_TRUCKS", truckRes.data);
      commit("SET_DRIVERS", driverRes.data);
      commit("SET_LOGISTICS_LOADED", true);
    } catch (error) {
      console.error("Failed to fetch logistics data:", error);
    }
  },
  // async fetchPositionInfo(_, slug) {
  //     try {
  //         const response = await axiosInstance.get(`onboard/positions/${slug}/`);
  //         return response.data;
  //     } catch (error) {
  //         console.error("Failed to fetch position by slug:", error);
  //         throw error;
  //     }
  // }
};

const getters = {
  getTrucks: (state) => state.trucks,
  getDrivers: (state) => state.drivers,
  isLogisticsLoaded: (state) => state.logisticsLoaded,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};


